import * as React from 'react';
import './h-busy-spinner.css';
import { ImSpinner4, ImSpinner9, ImSpinner2, ImSpinner10 } from 'react-icons/im';
import { ReactModel } from '../../react-model/react-model';

export type HBusySpinProps<T> = React.HTMLAttributes<SVGElement> & {
	model?: ReactModel<T>;
	field?: keyof NonNullable<T>;
	// btn_text?: keyof T;
	// /** When button clicked, set the value to this value */
	// set_to_value: any;
	// ref?: { current: any };
	//onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void,
	type?: '1' | '2' | '3' | '4';
	speed?: 'fast' | 'slow';
};

export function HBusySpinner<T>({ model, field, type, speed, ...props }: HBusySpinProps<T>) {
	let is_busy = undefined;
	if (model && field) {
		const { state } = model.useModel(field as any);
		is_busy = state;
		props = { ...props };
		if (!props.style) props.style = {};
		props.style.visibility = is_busy ? 'visible' : 'hidden';
	}
	let class_name = (props.className || '') + ' g-spinner ';
	if (speed === 'slow') {
		class_name += ' g-spinner-5000';
	}
	return (
		<>
			{(type === '1' || !type) && <ImSpinner9 {...props} className={class_name} />}
			{type === '2' && <ImSpinner2 {...props} className={class_name} />}
			{type === '3' && <ImSpinner10 {...props} className={class_name} />}
			{type === '4' && <ImSpinner4 {...props} className={class_name} />}
		</>
	);
}
